import { Recurso, UseCaseRecursoAsync } from 'lib.common/dist/CleanArch';
import { ErrDevGenerico } from 'lib.common/dist/errorHandler';
import { Producto } from '../entities/Productos.entity';
import { ProductosRepository } from '../repository/ProductosRepository';

export class GetAllProductosUseCase<
    T_OUT extends Producto,
> extends UseCaseRecursoAsync<
    null,
    T_OUT[]
> {
    private repository: ProductosRepository<T_OUT>;
    constructor(repository: ProductosRepository<T_OUT>) {
        super();
        this.repository = repository;
    }

    async call(input: null): Promise<Recurso<T_OUT[]>> {
        try {
            return this.repository.getAllProductos();
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT[]>(errorCapa);
        }
    }
}